import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken, accessDenied, currentNormalUser } from '@/utils/auth' // get token from cookie


NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login'] // no redirect whitelist
router.beforeEach(async(to, from, next) => {
    // start progress bar
    NProgress.start()


    // determine whether the user has logged in
    const hasToken = getToken()
    if (hasToken) {
        await accessDenied(to.path)
        if (to.path === '/login') {
            // if is logged in, redirect to the home page
            next({ path: '/' })
            NProgress.done()
        } else {
            if (to.matched.length === 0) {
                next('/404') // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
                NProgress.done()
            }
            const hasName = store.getters.name
            if (hasName) {
                next()
            } else {
                try {
                    // get user info
                    // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
                    await store.dispatch('user/getUserSectionInfoByToken', to.path)
                    await store.dispatch('user/getAllProvince')
                    if (currentNormalUser()) {
                        await store.dispatch('user/getUserBrands')
                    }
                        // generate accessible routes map based on roles
                        // await store.dispatch('permission/getRolePermissionList', { pageNo: '', pageSize: '' })

                    // // dynamically add accessible routes
                    // router.addRoutes(accessRoutes)

                    // hack method to ensure that addRoutes is complete
                    // set the replace: true, so the navigation will not leave a history record
                    next({ replace: true })
                } catch (error) {
                    // remove token and go to login page to re-login
                    Message.error(error.message || 'Has Error')
                    await store.dispatch('user/resetToken')
                    next(`/login?redirect=${to.path}`)
                    NProgress.done()
                }
            }
        }
    } else {
        /* has no token*/
        if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next()
        } else {
            // other pages that do not have permission to access are redirected to the login page.
            next(`/login?redirect=${to.path}`)
            NProgress.done()
        }
    }
})

router.afterEach(() => {
    // finish progress bar
    NProgress.done()
})